export const GetCollaboratorsApi = Symbol.for('GetCollaboratorsApi');
